import { Capacitor } from '@capacitor/core'
import { ThemeMode } from '@apps-common/config/theme'
import { useProjectHook } from '@apps-common/hooks/useProjectHook'
import { useTheme } from '@apps-common/hooks/useTheme'
import { FiMonitor, FiMoon, FiSun } from 'react-icons/fi'
import { IoIosPhonePortrait } from 'react-icons/io'

interface ThemeSelectorProps {
  size?: 'sm' | 'md'
  mmActiveColorClasses?: string
}

const OPTIONS = [
  { value: ThemeMode.system as const, Icon: FiMonitor, label: 'System' },
  { value: ThemeMode.light as const, Icon: FiSun, label: 'Light' },
  { value: ThemeMode.dark as const, Icon: FiMoon, label: 'Dark' }
]

export const ThemeSelector = ({ size = 'sm', mmActiveColorClasses }: ThemeSelectorProps) => {
  const { themeMode, setThemeMode } = useTheme()
  const activeColor = useProjectHook('bg-brand text-on-brand', mmActiveColorClasses || 'bg-text/80 text-surface-2')

  const isSm = size === 'sm'
  const isNative = Capacitor.isNativePlatform()

  return (
    <div
      className={`
          inline-flex items-center rounded-full border border-border bg-surface
          ${isSm ? 'p-[2px]' : 'p-1'}
        `}
    >
      {OPTIONS.map(({ value: mode, Icon, label }) => {
        const active = themeMode === mode
        const ThemeIcon = mode === ThemeMode.system && isNative ? IoIosPhonePortrait : Icon

        return (
          <button
            key={mode}
            type='button'
            aria-label={`Theme: ${label}`}
            onClick={(e) => {
              e?.stopPropagation()
              setThemeMode(mode)
            }}
            className={`
                flex items-center justify-center rounded-full transition
                ${isSm ? 'h-[31px] w-[31px]' : 'h-[40px] w-[40px]'}
              ${active ? activeColor : 'text-text-muted hover:text-text hover:bg-surface-2'}
              `}
          >
            <ThemeIcon className='text-[1rem]' />
          </button>
        )
      })}
    </div>
  )
}
